import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "27",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("path", {
        id: "a",
        d: "M0 0h31.063v26.562H0z"
      })
    ], -1),
    _createElementVNode("g", {
      transform: "translate(.708 .321)",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("use", { "xlink:href": "#a" }),
      _createElementVNode("path", {
        d: "M17.824 12.183v1.35h-3.373V8.12h3.262v1.347h-1.898v.63h1.796v1.344h-1.794v.742h2.005l.002-.001Zm.65 1.351 1.65-5.417h1.938l1.65 5.417h-1.417l-.307-1.048h-1.783l-.31 1.048h-1.42.003-.003Zm2.128-2.395h.983l-.448-1.53h-.083l-.454 1.53h.002Zm3.792-3.021h1.364v4.066h2.018c-.552-7.375-6.417-8.97-11.742-8.97h-5.68v4.908h.84c1.531 0 2.485 1.028 2.485 2.684 0 1.706-.929 2.727-2.485 2.727h-.843v9.82h5.682c8.66 0 11.675-3.982 11.781-9.822h-3.417V8.114l-.004.003.001.001Zm-14.04 1.35v2.716h.839c.584 0 1.124-.165 1.124-1.376 0-1.186-.602-1.338-1.124-1.338h-.839v-.002Zm-1.807 1.355c0 1.607-1.317 2.91-2.94 2.91-1.62 0-2.937-1.304-2.937-2.909 0-1.605 1.316-2.907 2.939-2.907 1.624 0 2.94 1.304 2.94 2.908l-.002-.002Zm-5.303 12.53H7.97V15.02H3.242v8.331h.002ZM16.034 0C29.11 0 31.063 8.303 31.063 13.252c0 8.583-5.337 13.31-15.029 13.31H0V0h16.034ZM1.264 1.249v24.064h14.769c8.915 0 13.77-4.112 13.77-12.063 0-8.17-5.262-12.002-13.77-12.002H1.262l.001.001Z",
        fill: "currentColor",
        "fill-rule": "nonzero",
        mask: "url(#b)"
      })
    ], -1)
  ])))
}
export default { render: render }